// import { generateCartMarker } from './generator.js';

import { isEmpty } from 'lodash';
import { preencherCampos } from '../utils/services';
const { href } = location;
const baseURL = href.includes('localhost') ? 'http://localhost/seguraid/' : 'https://seguraid.com.br/';

const handleButtonCheckout = document.getElementsByClassName("payment_method");
const checkoutForm = document.getElementById("form_payment_confirm");
const buttonHiddenPopulation = checkoutForm.elements["payment_method"];
const recurrent = document.getElementById("automatic_bill_payment");
const zipcodeField = document.getElementById('address_zipcode');
const cpfCnpjField = document.getElementById('checkout_identity');
const qtdItens = document.getElementById('qtdItens');
const citiesField = document.getElementById('cities-field');
const partnersField = document.getElementById('partners-list');
const CSRFToken = document.querySelector('[name="csrf-token"]');
const paymentButton = document.getElementById('payment_confirm');
const checkoutProductType = document.getElementById('product-type');
let isFirstTimeOnPayment = true;

Array.from(handleButtonCheckout).forEach((outerElem) => {
  outerElem.addEventListener("click", ({ target }) => {
    // checkoutForm.action = target.dataset.action;
    buttonHiddenPopulation.value = outerElem.getAttribute("name");
  });
});

recurrent?.addEventListener("change", ({ target }) => {
  buttonHiddenPopulation.value = target.getAttribute("name");
  if (!target.checked) {
    buttonHiddenPopulation.value = "payment_credit_card";
  }
});

$("input[name=payment_method]").on("change", function () {
  console.log('change')
  if (this.id == "payment_credit_card") {
    $("#container_credit_card").show();
    $("#container_bank_slip").hide();
    $("#container_pix").hide();
    $("#confirm_payment").show();
    $("#payment_method").val(this.id);
    $("#payment_confirm").val("Finalizar pagamento");
  } else if (this.id == "payment_bank_slip") {
    $("#container_credit_card").hide();
    $("#container_bank_slip").show();
    $("#container_pix").hide();
    $("#confirm_payment").show();
    $("#payment_method").val(this.id);
    $("#payment_confirm").val("Gerar boleto");
  } else if (this.id == "payment_pix") {
    $("#container_credit_card").hide();
    $("#container_bank_slip").hide();
    $("#container_pix").show();
    $("#confirm_payment").show();
    $("#payment_method").val(this.id);
    $("#payment_confirm").val("Gerar QR Code");
  } else {
    $("#container_credit_card").hide();
    $("#container_bank_slip").hide();
    $("#container_pix").hide();
    $("#confirm_payment").hide();
    $("#payment_method").val();
    $("#payment_confirm").prop("disabled", true);
  }
});


// Máscaras
// var docOptions = {
// 	onKeyPress: function (cpf, ev, el, op) {
// 		var masks = ["000.000.000-000", "00.000.000/0000-00"];
// 		$("#identity").mask(cpf.length > 14 ? masks[1] : masks[0], op);
// 	},
// };

$("#identity").length > 11
  ? $("#identity").mask("00.000.000/0000-00")
  : $("#identity").mask("000.000.000-00#");

$("#address_zipcode").mask("00000-000");
$("#checkout_number").mask("(00) 00000-0009");

$("#credit_card_number").mask("0000 0000 0000 9999 9999 9999");
$("#debit_card_number").mask("0000 0000 0000 0000");
$("#credit_card_expiration_date").mask("00/0000");
$("#debit_card_expiration_date").mask("00/0000");
$(".cvv").mask("0009");

const numberCustomNavs = Array.from(document.querySelectorAll(".checkout-custom-tab"));

numberCustomNavs?.forEach((elem, index, array) => {
  if (!numberCustomNavs) return;

  elem.addEventListener("click", () => {
    changeCustomTabContent(elem, index, array);
  });
});

const changeCustomTabContent = (elem, index, array) => {

  const parentElement = elem.parentElement;
  const parentDataTarget = elem.parentElement.dataset.tabTarget;
  const targetTabElement = document.getElementById(elem.dataset.customTarget);

  if (!parentDataTarget && !targetTabElement) return;

  const parentDataTargetElement = document.getElementById(parentDataTarget);
  const customTargets = Array.from(parentDataTargetElement.querySelectorAll(".checkout-custom-tab-content"));
  const customTabTriggers = Array.from(parentElement.querySelectorAll(".checkout-custom-tab"));

  customTargets.forEach((customTarget) => {
    customTarget.classList.remove("active");
    customTarget.setAttribute("aria-hidden", "true");

    customTabTriggers.forEach(customTabTrigger => {
      customTabTrigger.classList.remove('active')
    });
    elem.classList.add('active');

    if (customTarget.id === targetTabElement.id) {
      customTarget.classList.add("active");
      customTarget.setAttribute("aria-hidden", "false");
    };
  });
};

const submitCreditCard = document.getElementById("payment_confirm_credit");
const submitDebittCard = document.getElementById("payment_confirm_debit");

submitDebittCard?.addEventListener("click", (e) => {
  const creditCardHolder = document.getElementById("debit_card_holder");
  const creditCardNumber = document.getElementById("debit_card_number");
  const creditCardExpirationDate = document.getElementById(
    "debit_card_expiration_date"
  );
  const creditCardCVV = document.getElementById("debit_card_cvv");
  const fields = [
    creditCardHolder,
    creditCardNumber,
    creditCardExpirationDate,
    creditCardCVV,
  ];

  handlerCreditCardFields(fields);
  if (!validateCreditCard) {
    e.preventDefault();
  }
});

submitCreditCard?.addEventListener("click", (e) => {
  const creditCardHolder = document.getElementById("credit_card_holder");
  const creditCardNumber = document.getElementById("credit_card_number");
  const creditCardExpirationDate = document.getElementById(
    "credit_card_expiration_date"
  );
  const creditCardCVV = document.getElementById("credit_card_cvv");
  const fields = [
    creditCardHolder,
    creditCardNumber,
    creditCardExpirationDate,
    creditCardCVV,
  ];

  handlerCreditCardFields(fields);
  if (!validateCreditCard) {
    e.preventDefault();
  }
});

buttonHiddenPopulation.onsubmit = () => {
  return validateCreditCard();
};

const handlerCreditCardFields = (fields) => {
  const [
    creditCardHolder,
    creditCardNumber,
    creditCardExpirationDate,
    creditCardCVV,
  ] = fields;
  validateCreditCard(
    creditCardHolder,
    creditCardNumber,
    creditCardExpirationDate,
    creditCardCVV
  );
  fields.forEach((field) => {
    field.addEventListener("blur", () => {
      validateCreditCard(
        creditCardHolder,
        creditCardNumber,
        creditCardExpirationDate,
        creditCardCVV
      );
    });
  });
};

const validateCreditCard = (
  creditCardHolder,
  creditCardNumber,
  creditCardExpirationDate,
  creditCardCVV
) => {
  const validateCardHolder = validateCreditCardHolder(
    creditCardHolder.value
  );
  const validateCardNumber = validateCreditCardNumber(
    creditCardNumber.value
  );
  const validateCardExpirationDate = validateCreditCardExpirationDate(
    creditCardExpirationDate.value
  );
  const validateCardCVV = validateCreditCardCVV(+creditCardCVV.value);
  const handlerErrorField = document.getElementById(
    submitCreditCard.dataset.error
  );
  const errorFieldStatus = errorFieldVerifier(
    validateCardHolder,
    validateCardNumber,
    validateCardExpirationDate,
    validateCardCVV
  );

  if (!errorFieldStatus) {
    const stringError =
      "Um ou mais campos estão inválidos, Por favor revise seus dados e tente novamente";
    handlerErrorField.classList.remove("hidden");
    handlerErrorField.classList.add("show");
    handlerErrorField.textContent = stringError;
    submitCreditCard.setAttribute("disabled", "disabled");
  } else {
    handlerErrorField.classList.remove("show");
    handlerErrorField.classList.add("hidden");
    handlerErrorField.textContent = "";
    submitCreditCard.removeAttribute("disabled");
  }

  creditCardCVV.addEventListener("blur", () => {
    validateCreditCardCVV(+creditCardCVV.value);
  });
};

const validateCreditCardHolder = (holder) => {
  const length = holder.split(" ").length;
  let aux = true;
  length < 2 ? (aux = false) : "";
  return aux;
};

const validateCreditCardNumber = (value) => {
  if (/[^0-9-\s]+/.test(value) || value.length < 1) return false;

  let nCheck = 0,
    bEven = false;
  value = value.replace(/\D/g, "");

  for (let n = value.length - 1; n >= 0; n--) {
    let cDigit = value.charAt(n),
      nDigit = parseInt(cDigit, 10);
    if (bEven && (nDigit *= 2) > 9) nDigit -= 9;
    nCheck += nDigit;
    bEven = !bEven;
  }

  return nCheck % 10 == 0;
};

const validateCreditCardExpirationDate = (date) => {
  const splitted = date.split("/");
  const [month, year] = [+splitted[0], +splitted[1]];
  let aux = true;
  !month || !year || typeof month != "number" || typeof year != "number"
    ? (aux = false)
    : "";
  const actualDate = new Date();
  const actualMonth = +(actualDate.getMonth() + 1);
  const actualYear = +actualDate.getFullYear();
  month > 12 ||
    actualYear > year ||
    (actualYear == year && actualMonth > month)
    ? (aux = false)
    : "";
  return aux;
};

const validateCreditCardCVV = (number) => {
  let aux = true;
  String(number).length < 3 ||
    String(number).length > 4 ||
    typeof number != "number"
    ? (aux = false)
    : "";
  return aux;
};

const errorFieldVerifier = (holder, number, date, cvv) => {
  let aux = true;
  !holder || !number || !date || !cvv ? (aux = false) : "";

  return aux;
};

$(document).on("change", "#parcel_number", function () {
  $("#quantity").html(" ");
  $("#quantity").html($(this).val());
});

const generateProductCard = ({ productName, dataColor, dataSize, productQuantity, productValue, imageSrc, idGeneric, idSize, idColor }) => {
  const span = document.createElement('span');
  const row = document.createElement('div');
  const col = document.createElement('div');
  const img = document.createElement('img');
  const div1 = document.createElement('div');
  const div2 = document.createElement('div');
  const title = document.createElement('h1');
  const description = document.createElement('p');
  const price = document.createElement('p');
  const hr = document.createElement('hr');
  const inputIdProduct = document.createElement('input');
  const inputColor = document.createElement('input');
  const inputSize = document.createElement('input');
  const quatity = document.createElement('input');
  const inputPrice = document.createElement('input');

  row.classList.add('row', 'pb-2', 'mt-2', 'border-bottom');
  col.classList.add('col-2');
  img.classList.add('w-100', 'img-fluid');
  div1.classList.add('col-8', 'col-md-10', 'd-flex', 'flex-column', 'justify-content-between');
  div2.classList.add('mb-2');
  title.classList.add('accordion-title');
  description.classList.add('accordion-description');

  inputIdProduct.type = 'hidden';
  inputIdProduct.name = 'productsCart[]';
  inputIdProduct.id = `id-product-${idGeneric}`;
  inputIdProduct.value = idGeneric;

  inputColor.type = 'hidden';
  inputColor.name = 'productsColors[]';
  inputColor.id = `id-color-${idColor}`;
  inputColor.value = idColor;

  inputSize.type = 'hidden';
  inputSize.name = 'productsSize[]';
  inputSize.id = `id-size-${idSize}`;
  inputSize.value = idSize;

  img.src = imageSrc;
  img.width = '150';
  img.height = '150';
  title.textContent = productName;
  description.textContent = `Cor: ${dataColor} | Tamanho: ${dataSize} | Quantidade: ${productQuantity}`;
  price.textContent = `Valor: R$ ${(productValue * productQuantity).toFixed(2)}`;

  quatity.type = 'hidden';
  quatity.name = 'productsQuantity[]';
  quatity.id = `quantity-product-${idGeneric}`;
  quatity.value = productQuantity;

  inputPrice.type = 'hidden';
  inputPrice.name = 'productsPrice[]';
  inputPrice.id = `price-product-${idGeneric}`;
  inputPrice.value = (productValue * productQuantity);

  row.append(col, div1, inputIdProduct, inputColor, inputSize, quatity, inputPrice);
  col.append(img);
  div1.append(div2, price);
  div2.append(title, description);
  span.append(hr);


  return row;
};

const loadProductCard = (product, list) => {
  const card = generateProductCard(product);
  list.append(card);
  // verifyProductQuantity();
  // generateCartMarker();
};

const cartList = document.getElementById('cart-list');
const storedProducts = JSON.parse(localStorage.getItem('products')) || [];

if (qtdItens) {
  qtdItens.textContent = `${storedProducts.length} ${storedProducts.length > 1 ? 'Itens' : 'Item'}`;
}

if (storedProducts.length > 0) {
  // storedProducts.forEach(product => loadProductCard(product, cartList));
  // updateProductIndex();
}

zipcodeField.addEventListener('blur', () => preencherCampos(zipcodeField.value, zipcodeField));

$('.cpf').mask('000.000.000-00');
$('.cnpj').mask('00.000.000/0000-00');
$('.phone').mask('(00) 90000-0000');
$('.municipal_subscription').mask('0000000000');
$('.state_subscription').mask('00000000000');
$('.cpf').mask('000.000.000-00');

$(document).on('click', ' .make_method', function () {
  $('#make_method').val($(this).data('action'));
});

// $(document).on('change', citiesField, function(){
//   let cidade = $(this).val();
//   $.ajax({
//     url: "checkout/fetch-partners",
//     dataType: 'script',
//     cache: false,
//     contentType: false,
//     processData: false,
//     data: { cidade : cidade },
//     dataType: "json",
//     type: 'post',
//     complete: function(data){
//       alert(data);
//       // var resposta = JSON.parse(data.responseText);
//       // if (resposta.success) {

//       // }
//     }
//   });
// });

const partnerTitle = `
  <p class="my-1">Escolha um Parceiro perto de você:</p>
`;

const partnerList = (id, partner) => `
  <ul class="list-group" title="Parceiros disponíveis">
    <li class="list-group-item">
      <div class="form-check">
        <input class="form-check-input" type="radio" id="${id}" name="id_partner" value="${id}">
        <label class="form-check-label" for="${id}">
          ${partner}
        </label>
      </div>
    </li>
  </ul>
`;

const populatePartnersList = (list) => {
  const partnerListElementMap = list.map((element) => {
    const partnerid = element.juridical_id_partner || element.physical_id_partner
    const partnerName = element.trade_name || `${element.name} ${element.surname}`;

    return partnerList(partnerid, partnerName)
  }).join('');

  let partnersListNewHTML = partnerTitle + partnerListElementMap;

  partnersField.innerHTML = partnersListNewHTML;
}

const requestPartnersList = async (cityName) => {
  const body = new FormData();

  partnersField.innerHTML = '<p>Carregando...</p>';

  body.append('city_name', cityName);

  try {
    const request = await fetch(`${baseURL}api/parceiros`, {
      method: 'POST',
      headers: {
        "X-CSRF-TOKEN": CSRFToken.content,
      },
      body
    });
    const partnersList = await request.json();

    populatePartnersList(partnersList);
  } catch (error) {
    partnersField.innerHTML = `
      <span>Ocorreu um erro</span>
      <p>${error}</p>
    `;
  }
};

const handleCitySelection = async ({ target }) => {
  const { value } = target;

  if (!value) return;

  const partnersList = await requestPartnersList(value);

};

citiesField?.addEventListener('change', handleCitySelection);

function verifyUserJuridicalData() {
  let issetEmpty = false;

  if (isEmpty($("#checkout_cnpj").val())) {
    issetEmpty = true;
    $("#span_checkout_cnpj").removeClass("d-none");
    $("#span_checkout_cnpj").addClass("d-block");
  } else {
    $("#span_checkout_cnpj").addClass("d-none");
    $("#span_checkout_cnpj").removeClass("d-block");
  }

  if (isEmpty($("#checkout_corporate_name").val())) {
    issetEmpty = true;
    $("#span_checkout_razao").removeClass("d-none");
    $("#span_checkout_razao").addClass("d-block");
  } else {
    $("#span_checkout_razao").addClass("d-none");
    $("#span_checkout_razao").removeClass("d-block");
  }

  if (isEmpty($("#checkout_fantasy_name").val())) {
    issetEmpty = true;
    $("#span_fantasy_name").removeClass("d-none");
    $("#span_fantasy_name").addClass("d-block");
  } else {
    $("#span_fantasy_name").addClass("d-none");
    $("#span_fantasy_name").removeClass("d-block");
  }

  if (isEmpty($("#checkout_state_subscription").val())) {
    issetEmpty = true;
    $("#span_state_subscription").removeClass("d-none");
    $("#span_state_subscription").addClass("d-block");
  } else {
    $("#span_state_subscription").addClass("d-none");
    $("#span_state_subscription").removeClass("d-block");
  }




  if (isEmpty($("#address_zipcode").val())) {
    issetEmpty = true;
    $("#span_checkout_cep").removeClass("d-none");
    $("#span_checkout_cep").addClass("d-block");
  }

  if (isEmpty($("#address_district").val())) {
    issetEmpty = true;
    $("#span_checkout_bairro").removeClass("d-none");
    $("#span_checkout_bairro").addClass("d-block");
  }


  if (isEmpty($("#address_street").val())) {
    issetEmpty = true;
    $("#span_checkout_rua").removeClass("d-none");
    $("#span_checkout_rua").addClass("d-block");
  }

  if (isEmpty($("#address_number").val())) {
    issetEmpty = true;
    $("#span_checkout_number").removeClass("d-none");
    $("#span_checkout_number").addClass("d-block");
  }

  if (isEmpty($("#address_city_name").val())) {
    issetEmpty = true;
    $("#span_checkout_cidade").removeClass("d-none");
    $("#span_checkout_cidade").addClass("d-block");
  }


  if (isEmpty($("#address_state_initials").val())) {
    issetEmpty = true;
    $("#span_checkout_uf").removeClass("d-none");
    $("#span_checkout_uf").addClass("d-block");
  }

  //  tem q pegar a classe
  if (isEmpty($("#checkout_state_subscription").val())) {
    issetEmpty = true;
    $("#span_municipal_subscription").removeClass("d-none");
    $("#span_municipal_subscription").addClass("d-block");
  } else {
    $("#span_municipal_subscription").addClass("d-none");
    $("#span_municipal_subscription").removeClass("d-block");
  }

  if (isEmpty($("#checkout_cnpj_phone").val())) {
    issetEmpty = true;
    $("#span_cnpj_phone").removeClass("d-none");
    $("#span_cnpj_phone").addClass("d-block");
  } else {
    $("#span_cnpj_phone").addClass("d-none");
    $("#span_cnpj_phone").removeClass("d-block");
  }

  


  if (isEmpty($("#checkout_cnpj_email").val())) {
    issetEmpty = true;
    $("#span_cnpj_email").removeClass("d-none");
    $("#span_cnpj_email").addClass("d-block");
  } else {
    $("#span_cnpj_email").addClass("d-none");
    $("#span_cnpj_email").removeClass("d-block");
    if (!$("#checkout_cnpj_email").val().includes("@")) {
      issetEmpty = true;
      $("#span_checkout_email_invalid").removeClass("d-none");
      $("#span_checkout_email_invalid").addClass("d-block");
    } else   {
      $("#span_checkout_email_invalid").addClass("d-none");
      $("#span_checkout_email_invalid").removeClass("d-block");
    }
  }

  return issetEmpty;
}

function verifyUserPhysicalData(event) {
  let issetEmpty = false;

  if (isEmpty($("#checkout_name").val())) {
    issetEmpty = true;
    $("#span_checkout_name").removeClass("d-none");
    $("#span_checkout_name").addClass("d-block");
  }else {
    $("#span_checkout_name").addClass("d-none");
    $("#span_checkout_name").removeClass("d-block");
  }



  if (isEmpty($("#checkout_identity").val())) {
    issetEmpty = true;
    $("#span_checkout_cpf").removeClass("d-none");
    $("#span_checkout_cpf").addClass("d-block");
  }else {
    $("#span_checkout_cpf").addClass("d-none");
    $("#span_checkout_cpf").removeClass("d-block");
  }

  if (isEmpty($("#checkout_number").val())) {
    issetEmpty = true;
    $("#span_checkout_numero").removeClass("d-none");
    $("#span_checkout_numero").addClass("d-block");
  } else {
    $("#span_checkout_numero").addClass("d-none");
    $("#span_checkout_numero").removeClass("d-block");

  }


  

  if (isEmpty($("#checkout_cpf_email").val())) {
    issetEmpty = true;
    $("#span_checkout_cpf_email").removeClass("d-none");
    $("#span_checkout_cpf_email").addClass("d-block");
  } else   {
    $("#span_checkout_cpf_email").addClass("d-none");
    $("#span_checkout_cpf_email").removeClass("d-block");
    
    if (!$("#checkout_cpf_email").val().includes("@")) {
      issetEmpty = true;
      $("#span_checkout_email_invalid").removeClass("d-none");
      $("#span_checkout_email_invalid").addClass("d-block");
    } else   {
      $("#span_checkout_email_invalid").addClass("d-none");
      $("#span_checkout_email_invalid").removeClass("d-block");
    }
  }

  if (isEmpty($("#address_zipcode").val())) {
    issetEmpty = true;
    $("#span_checkout_cep").removeClass("d-none");
    $("#span_checkout_cep").addClass("d-block");
  }else   {
    $("#span_checkout_cep").addClass("d-none");
    $("#span_checkout_cep").removeClass("d-block");
  }

  if (isEmpty($("#address_district").val())) {
    issetEmpty = true;
    $("#span_checkout_bairro").removeClass("d-none");
    $("#span_checkout_bairro").addClass("d-block");
  } else   {
    $("#span_checkout_bairro").addClass("d-none");
    $("#span_checkout_bairro").removeClass("d-block");
  }


  if (isEmpty($("#address_street").val())) {
    issetEmpty = true;
    $("#span_checkout_rua").removeClass("d-none");
    $("#span_checkout_rua").addClass("d-block");
  } else {
    $("#span_checkout_rua").addClass("d-none");
    $("#span_checkout_rua").removeClass("d-block");
  }


  if (isEmpty($("#address_number").val())) {
    issetEmpty = true;
    $("#span_checkout_number").removeClass("d-none");
    $("#span_checkout_number").addClass("d-block");
  } else {
    $("#span_checkout_number").addClass("d-none");
    $("#span_checkout_number").removeClass("d-block");
  }


  if (isEmpty($("#address_city_name").val())) {
    issetEmpty = true;
    $("#span_checkout_cidade").removeClass("d-none");
    $("#span_checkout_cidade").addClass("d-block");
  }  else {
    $("#span_checkout_cidade").addClass("d-none");
    $("#span_checkout_cidade").removeClass("d-block");
  }


  if (isEmpty($("#address_state_initials").val())) {
    issetEmpty = true;
    $("#span_checkout_uf").removeClass("d-none");
    $("#span_checkout_uf").addClass("d-block");
  } else {
    $("#span_checkout_uf").addClass("d-none");
    $("#span_checkout_uf").removeClass("d-block");
  }


  return issetEmpty;
}

function verifyPaymentData(event) {
  let issetEmpty = false;
  if (isEmpty($("#debit_card_number").val())) {
    issetEmpty = true;
    $("#debit_card_number_span").removeClass("d-none");
    $("#debit_card_number_span").addClass("d-block");
  } else {
    $("#debit_card_number_span").addClass("d-none");
    $("#debit_card_number_span").removeClass("d-block");
  }

  if (isEmpty($("#debit_card_holder").val())) {
    issetEmpty = true;
    $("#debit_card_holder_span").removeClass("d-none");
    $("#debit_card_holder_span").addClass("d-block");
  } else {
    $("#debit_card_holder_span").addClass("d-none");
    $("#debit_card_holder_span").removeClass("d-block");
  }

  if (isEmpty($("#debit_card_expiration_date").val())) {
    issetEmpty = true;
    $("#debit_card_expiration_date_span").removeClass("d-none");
    $("#debit_card_expiration_date_span").addClass("d-block");
  } else {
    $("#debit_card_expiration_date_span").addClass("d-none");
    $("#debit_card_expiration_date_span").removeClass("d-block");
  }

  if (isEmpty($("#debit_card_cvv").val())) {
    issetEmpty = true;
    $("#debit_card_cvv_span").removeClass("d-none");
    $("#debit_card_cvv_span").addClass("d-block");
  } else {
    $("#debit_card_cvv_span").addClass("d-none");
    $("#debit_card_cvv_span").removeClass("d-block");
  }

  return issetEmpty;
};

$(document).on("click", ".muda-div", function (event) {
  // event.preventDefault();
  const productType = checkoutProductType.value;
  const actual = $(this).data("actual")
  const next = $(this).data("next")

  let issetEmpty = false;

  if (actual == "container-meio") {

    if ($('[name="is_online"]:checked').val() == '0') {


    } else if ($('[name="is_online"]:checked').val() == '1') {

    }
     else {
      // nao escolhido
     issetEmpty = true ;
    }
  }

  if (actual == "container-dados") {

    if (productType == "juridical") {
      issetEmpty = verifyUserJuridicalData();

    } else {
      issetEmpty = verifyUserPhysicalData();
    }
  }


  if (actual == "container-pagamento") {
    verifyPaymentData(event);
  }

  if (next == "container-pagamento") {
    if (isFirstTimeOnPayment) {
      const paymentButton = document.getElementById('payment_confirm');

      paymentButton.addEventListener("click", (event) => {
        // event.preventDefault();

        verifyPaymentData(issetEmpty)
      })
      isFirstTimeOnPayment = false;
    }
  }

  if (!issetEmpty) {
    $("#" + actual).hide();
    $("#" + next).show();
    $('#container-dados span').addClass("d-none");

    $("#nav-" + actual).removeClass("nav-progress-active");
    $("#nav-" + next).addClass("nav-progress-active");
  }
})

paymentButton.addEventListener("click", function (event) {
  const productType = checkoutProductType.value;
  let issetEmpty = false;

  if (productType == "juridical") {
    issetEmpty = verifyUserJuridicalData();
  } else {
    issetEmpty = verifyUserPhysicalData();
  }
  
  if (issetEmpty) {
    event.preventDefault();
  }
});


